import React, { FC, ReactElement } from 'react';
// Components
import ModalButton, { ButtonType } from './templates/modalButton';
import ModalButtonContainer from './templates/modalButtonContainer';
import Text from '../text';
// Resources
import { stringsRes } from '../../resources/strings';
import { PropsFromModal } from './createModalHOC';
import useGlobalStyles from '../hook/useGlobalStyles';

interface DeleteProps extends PropsFromModal {
    description?: string;
    onConfirmAction?: () => void;
    onCancelAction?: () => void;
}

const Delete: FC<DeleteProps> = (props): ReactElement => {
    const { onRequestClose, description, onConfirmAction, onCancelAction } = props;
    const globalClasses = useGlobalStyles();

    const onClickConfirm = (): void => {
        if (onConfirmAction) {
            onConfirmAction();
        }
        onRequestClose();
    };

    const onClickCancel = (): void => {
        if (onCancelAction) {
            onCancelAction();
        }
        onRequestClose();
    };

    return (
        <div className="LCDeleteContainer">
            <div className={globalClasses.flexCol}>
                <Text.Description16 customColor="grey" text={description} />
            </div>
            <ModalButtonContainer>
                <ModalButton type={ButtonType.CANCEL} onClick={onClickCancel} />
                <ModalButton type={ButtonType.ERROR} onClick={onClickConfirm} label={stringsRes.common.delete} />
            </ModalButtonContainer>
        </div>
    );
};

export default Delete;
